var _path, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3327 19.4993L19.6577 16.9993L15.3327 14.4993V19.4993ZM24.966 12.9743C25.0743 13.366 25.1493 13.891 25.1993 14.5577C25.2577 15.2243 25.2827 15.7993 25.2827 16.2993L25.3327 16.9993C25.3327 18.8243 25.1993 20.166 24.966 21.0243C24.7577 21.7743 24.2743 22.2577 23.5243 22.466C23.1327 22.5743 22.416 22.6493 21.316 22.6993C20.2327 22.7577 19.241 22.7827 18.3243 22.7827L16.9993 22.8327C13.5077 22.8327 11.3327 22.6993 10.4743 22.466C9.72435 22.2577 9.24102 21.7743 9.03268 21.0243C8.92435 20.6327 8.84935 20.1077 8.79935 19.441C8.74102 18.7743 8.71602 18.1993 8.71602 17.6993L8.66602 16.9993C8.66602 15.1743 8.79935 13.8327 9.03268 12.9743C9.24102 12.2243 9.72435 11.741 10.4743 11.5327C10.866 11.4243 11.5827 11.3493 12.6827 11.2993C13.766 11.241 14.7577 11.216 15.6743 11.216L16.9993 11.166C20.491 11.166 22.666 11.2993 23.5243 11.5327C24.2743 11.741 24.7577 12.2243 24.966 12.9743Z",
    fill: "#8E8E8E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.9232,
    cy: 16.5385,
    r: 16.5385,
    fill: "#6C6C6C",
    fillOpacity: 0.39
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.9232,
    cy: 16.5385,
    r: 16.125,
    stroke: "#8E8E8E",
    strokeOpacity: 0.31,
    strokeWidth: 0.826923
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.c7124d2cb743c59edcdd99323a045851.svg";
export { ForwardRef as ReactComponent };